import React, { useState, useEffect } from 'react';
import api from '../api';
import { format, isPast, formatDistanceToNow } from 'date-fns';

export default function Demos() {
  const [demos, setDemos] = useState([]);
  const [filter, setFilter] = useState('upcoming');

  useEffect(() => { api.get('/demos/all').then(r => setDemos(r.data)); }, []);

  const upcoming = demos.filter(d => d.scheduledDemoAt && !isPast(new Date(d.scheduledDemoAt)));
  const past = demos.filter(d => d.scheduledDemoAt && isPast(new Date(d.scheduledDemoAt)));
  const shown = filter === 'upcoming' ? upcoming : past;

  return (
    <div className="fadein">
      <div className="page-header">
        <div>
          <div className="page-title">Demos</div>
          <div className="page-subtitle">{upcoming.length} upcoming · {past.length} past</div>
        </div>
      </div>

      <div className="tabs">
        <button className={`tab ${filter === 'upcoming' ? 'active' : ''}`} onClick={() => setFilter('upcoming')}>
          Upcoming ({upcoming.length})
        </button>
        <button className={`tab ${filter === 'past' ? 'active' : ''}`} onClick={() => setFilter('past')}>
          Past ({past.length})
        </button>
      </div>

      {shown.length === 0 ? (
        <div className="card">
          <div className="empty"><div className="empty-icon"></div><p>No {filter} demos</p></div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
          {shown.map(d => {
            const isUp = !isPast(new Date(d.scheduledDemoAt));
            return (
              <div key={d._id} className="card" style={{ padding: 16 }}>
                {/* Date badge + lead name */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ width: 40, height: 40, background: isUp ? 'var(--accent-dim)' : 'var(--surface-2)', borderRadius: 'var(--r)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: `1px solid ${isUp ? 'var(--accent-border)' : 'var(--border)'}`, flexShrink: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: isUp ? 'var(--accent)' : 'var(--text-3)', lineHeight: 1 }}>
                        {format(new Date(d.scheduledDemoAt), 'dd')}
                      </div>
                      <div style={{ fontSize: 9, color: isUp ? 'var(--accent)' : 'var(--text-3)', fontWeight: 600, textTransform: 'uppercase' }}>
                        {format(new Date(d.scheduledDemoAt), 'MMM')}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--text-1)' }}>{d.lead?.name}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 1 }}>{d.lead?.number} · {d.lead?.city}</div>
                    </div>
                  </div>
                  <span className={`badge badge-${isUp ? 'schedule_demo' : 'completed'}`}>
                    {isUp ? 'Upcoming' : 'Past'}
                  </span>
                </div>

                {/* Time row */}
                <div style={{ background: 'var(--surface-2)', borderRadius: 'var(--r-sm)', padding: '8px 10px', marginBottom: 10, border: '1px solid var(--border-light)' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-1)' }}>
                    {format(new Date(d.scheduledDemoAt), 'hh:mm a')}
                  </div>
                  {isUp && (
                    <div style={{ fontSize: 12, color: 'var(--accent)', marginTop: 1 }}>
                      {formatDistanceToNow(new Date(d.scheduledDemoAt), { addSuffix: true })}
                    </div>
                  )}
                </div>

                {d.demoDetails && (
                  <div style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 8 }}>{d.demoDetails}</div>
                )}
                {d.notes && (
                  <div style={{ fontSize: 12, color: 'var(--text-3)', fontStyle: 'italic', borderTop: '1px solid var(--border-light)', paddingTop: 8 }}>
                    "{d.notes}"
                  </div>
                )}
                <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 8 }}>By {d.calledBy?.name}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
